<template>
    <div class="mobile-hamburger slideout-menu-container">
		<Slideout
            easing="cubic-bezier(.32,2,.55,.27)"
			menu="#menu"
			panel="#panel"
            :toggleSelectors="['.hamburger']" >
				<main id="panel">
                    <header>
                        <div class="hamburger-container"
							tabindex="0"
							role="button"
							aria-label="user menu"
							@keydown.enter="toggleNav()">
                            <BaseIcon
                                icon="bars" 
                                size="2x" 
                                :classNames="[{'hamburger': true, 'is-clickable': true}]"/>
                        </div>
                    </header>
                </main>
        </Slideout>
		<nav id="menu" ref="slideoutMenu">
			<div class="nav-menu-items">
					<div>
						<BaseIcon
							tabindex="0"
							role="button"
							aria-label="close settings"
							@click="closeSlideout"
							icon="times" 
							size="2x"
							:classNames="[{'is-clickable': true, 'store-navigation-color': true, 'close-icon': true}]" />
					</div>
				<div id="links" class="no-highlight">
					<template v-for="(link, index) in links" >
							<NavigationItem 
								v-if="!link.isModal"
								:title="link.title "
								:route="link.route"
								:key="index"
								@click="toggleNav" />
							<!-- modal -->
							<a v-else
								:key="index"
								class="is-size-5"
								:href="`/?${link.title}`"
								@click.prevent="() => {
									_triggerModal(link);
									toggleNav();
								}">
								<div class="slideout-navbar-item">
									{{link.title}}
								</div>
							</a>  
					</template>
				</div>
			</div>
		</nav>
    </div>
</template>


<script>
import Slideout from 'vue-slideout';
import NavigationItem from '@/components/header/NavigationItem';
import { mapActions } from 'vuex';
import modalMixins from '@Mixin/modalMixin';
const ProfileEditor = () => System.import('@/components/account/ProfileEditor');
const ContentModal = () => System.import('@ContentModal');
const StoreLocator = () => System.import('@/components/store-locator/StoreLocator/StoreLocator');

export default {
	mixins: [
		modalMixins,
	],
    data() {
        return {
            hamburgerActive: true,
            isOpen: false,
            // move to be props
            links: [
                {
                    title: 'Home',
                    route: '/',
                    isModal: false
                },
                {
                    title: 'Profile',
                    route: '/profile',
                    modalName: 'Profile',
                    isModal: true,
                    component: ProfileEditor
                },
                {
                    title: 'Locations',
                    route: '/locations',
                    modalName: 'contentModal',
                    isModal: true,
                    component: StoreLocator,
                    modalWidth: '65%'
                },
                {
                    title: 'Sign Out',
                    route: '/logout'
                }
            ]
        };
    },
    methods: {
        closeSlideout() {
            this.toggleNav();
        },
        beforeRouteLeave(to, from, next) {
            next();
        },
        toggleNav() {
            this.$children[0].slideout.toggle();
        },
		_triggerModal(link) {
			this.triggerModal(link);
        }
    },
    components: {
        NavigationItem,
        Slideout
    }
};
</script>

<style lang='scss'>
@import 'globalStyles';

@keyframes slideInLeft {
    from {
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
    }

    to {
        -webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
    }
}

@keyframes slideOutLeft {
    from {
        -webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
    }

    to {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
    }
}

.slideout-open .hamburger {
    visibility: hidden;
}

.slideout-menu {
    position: fixed;
    top: 0;
    bottom: 0;
	width: 20vw;
    height: 100vh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    z-index: $zTopInteractionLayer + 1;
    display: none;
    background-color: #efefef;
}

.slideout-menu-left {
	left: 0;
}

.slideout-menu-right {
	right: 0;
}

.slideout-open,
.slideout-open body,
.slideout-open .slideout-panel {
    overflow: hidden;
}

.slideout-open .slideout-menu {
    display: block;
}

.slide-out {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: $zTopInteractionLayer + 1;
    top: 0;
    left: 0;
    background-color: #efefef;
    overflow-x: hidden;
}

.nav-menu-items {
    padding: 1em;
    width: 100%;
}
.nav-menu-items #links {
    margin-top: 1em;
}

#links:last-child {
    border-bottom: 1px solid $greySeparator;
}
.show-slide-out {
    width: 100%;
}
.hamburger {
    vertical-align: middle;
    color: $navigationItemColor;
}

.navbar-item.hamburger-container {
    border-right: 1px solid $greyOutline;
    padding: 1em;
    left: 0;
    position: absolute;
}

@include mobile {
    .slideout-menu {
        width: 100%;
    }
    .navbar-item.hamburger-container {
        left: 0;
        position: absolute;
    }

    .mobile-hamburger {
        position: relative;
        left: 0;
        top: 0;
        padding: 0.8rem 0.75rem;
		min-width: 23vw;
	}
}

@include tablet {
    .navbar-item.hamburger-container {
        left: 0;
        position: absolute;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header/SlideoutMenu.vue